import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CachedDataService } from '@services/data/cached-data.service';
import { BaseHttpService } from '@services/http/base-http.service';
import { AuthService } from '@services/http/auth.service';
import { Observable } from 'rxjs/Observable';
import { environment } from '@environments';
import { Router } from '@angular/router';


@Injectable()
export class UserService extends BaseHttpService {

  constructor(protected httpClient: HttpClient,
    protected cachedDataService: CachedDataService,
    protected router: Router,
    protected authService: AuthService
  ) {
    super(httpClient, cachedDataService, router, authService);
  }

  sendCode(phone: string): Observable<any> {
    const uri = environment.apiUri + 'user/code';
    const params = new HttpParams();

    return super.send('POST', uri, params, true, { phone: phone });
  }

  ConfirmCode(phone: string, code: string): Observable<any> {
    const uri = environment.apiUri + 'user/confirm';
    const params = new HttpParams();
    return super.send('PUT', uri, params, true, { phone: phone, code: code });
  }

  updateUserInfo(FullName: string, Email: string, Id: string, dateTimeOffset: number): Observable<any> {
    const uri = environment.apiUri + 'user';
    const params = new HttpParams();
    return super.send('PUT', uri, params, true, { FullName: FullName, Email: Email, Id: Id, dateTimeOffset: dateTimeOffset });
  }

  delete(userId: string) : Observable<any> {
    const uri = environment.apiUri + `user/${userId}?isHardDelete=true`;

    return super.send('DELETE', uri);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/http/user.service.ts